var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('data-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }